import { Children, ReactNode, useMemo, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

const InfiniteScrollWrapper = ({
    height,
    children: childrenNode,
}: {
    height: number | string;
    children: ReactNode;
}) => {
    const pageLength = 50;
    const [count, setCount] = useState(pageLength);

    const children = useMemo(() => Children.toArray(childrenNode), [childrenNode]);

    const next = () => {
        setCount((prevValue) => {
            return prevValue + pageLength;
        });
    };

    const visibleChildren = useMemo(() => children.slice(0, count), [count, children]);

    // When height is 'auto', infinite scroll detection doesn't work because
    // there's no fixed scrollable container. Render all children directly.
    if (height === 'auto') {
        return (
            <div
                className="infinite-scroll-auto-height"
                style={{ height: 'auto', overflow: 'auto' }}
            >
                {children}
            </div>
        );
    }

    return (
        <InfiniteScroll
            dataLength={count}
            next={next}
            height={height}
            hasMore={count < children.length}
            loader={<h4>Loading...</h4>}
        >
            {visibleChildren}
        </InfiniteScroll>
    );
};

export default InfiniteScrollWrapper;
